import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=468d4f99&"
import script from "./BlogItem.vue?vue&type=script&lang=js&"
export * from "./BlogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,BlogCategories: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogCategories.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
